import React from "react";
import styles from "./scss/menuoptions.module.scss";
import { Menu, Dropdown, Tooltip } from 'antd';
import { chats, initialStateModel } from "../../../models/model";
import { useSelector } from "react-redux";
import store from "../../../context/store/store";
import { Types } from "../../../context/action/action";
import { ChatService } from "../../../base/chatService";


type uploadFiles = {
  rightSideToggle: Function
  activeTab?: any
}

export default function MenuOptions({ rightSideToggle, activeTab }: uploadFiles) {
  const chatReducer: chats = useSelector((state: initialStateModel) => state.chatReducer);
  let meetingReducer: any = store.getState().meetingReducer;
  const {planBased} =meetingReducer;
  const menu = (
    <Menu>
      <Menu.Item onClick={() => rightSideChatToggle('files')} key={'files'}>Files</Menu.Item>
      <Menu.Item onClick={() => rightSideChatToggle('saved chat')} key={'saved'}>Saved</Menu.Item>
      <Menu.Item onClick={() => rightSideChatToggle('links')} key={'links'}>Links</Menu.Item>
    </Menu>
  );

  const rightSideChatToggle = (mode: string) => {
    rightSideToggle(mode);
    let KeyValue: string = mode === "event" ? "eventlist" : mode === "notes" ? "notelist" :
      mode === "task" ? "tasklist" : mode === "files" ? 'filesList' : mode === "links" ? 'linksList' : mode === "all" ? "all" : "savedchatList";
    store.dispatch({
      type: Types.CHAT_WINDOW_SLIDE_OPEN,
      payload: {
        isWindowSlide: true,
        isKey: KeyValue,
        isEdit: ""
      }
    });
  };
const cancelWindow = ()=>{
  ChatService.rightSideToogle();
}
  return (
    <>
      <div className={styles.menuoptions}>
        <ul>
          <Tooltip title="Profile"><li className={`${chatReducer.isKey === "" || chatReducer.isKey === "all" ? styles.active : styles.profiletab}`}
            onClick={() => rightSideChatToggle('all')}>
            <span className={`${chatReducer.isKey === "" || chatReducer.isKey === "all"? "icon__profilestamp green" : "icon__profilestamp "}`}></span></li></Tooltip>
            {/* <Tooltip title="Task"><li className={`${activeTab === 'task' || chatReducer.isKey === "tasklist" ? styles.active : styles.tasktab}`}
            onClick={() => rightSideChatToggle('task')}>
            <span className={`${activeTab === 'task' || chatReducer.isKey === "tasklist" ? "icon__tickfill green" : "icon__tickfill"}`}></span></li></Tooltip>
            
            <Tooltip title="Event"><li className={`${activeTab === 'event' || chatReducer.isKey === "eventlist" ? styles.active : styles.eventstab}`}
            onClick={() => rightSideChatToggle('event')}>
            <span className={`${activeTab === 'event' || chatReducer.isKey === "eventlist" ? "icon__noteactive green" : "icon__noteactive"}`}  ></span></li></Tooltip>
            
           <Tooltip title="Note"><li className={`${activeTab === 'notes' || chatReducer.isKey === "notelist" ? styles.active : styles.notestab}`}
            onClick={() => rightSideChatToggle('notes')}>
            <span className={`${activeTab === 'notes' || chatReducer.isKey === "notelist" ? "icon__eventactive green" : "icon__eventactive"}`}></span></li></Tooltip> */}
            
            <Tooltip title="File"><li className={`${activeTab === 'files' ? styles.active : styles.notestab}`}
            onClick={() => rightSideChatToggle('files')}>
            <span className={`${activeTab === 'files' ? "icon__filesactive green" : "icon__filesactive"}`}></span></li></Tooltip>

            <Tooltip title="Saved Chat"><li className={`${activeTab === 'saved chat' ? styles.active : styles.notestab}`}
            onClick={() => rightSideChatToggle('saved chat')}>
            <span className={`${activeTab === 'saved chat' ? "icon__savedactive green" : "icon__savedactive"}`}></span></li></Tooltip>
            <Tooltip title="Link"><li className={`${activeTab === 'links' ? styles.active : styles.notestab}`}
            onClick={() => rightSideChatToggle('links')}>
            <span className={`${activeTab === 'links' ? "icon__linksactive green" : "icon__linksactive"}`}></span></li></Tooltip>
          {/* <li><Dropdown overlay={menu} overlayClassName="customwidsetcon" trigger={['click']} placement="bottomRight">
            <span className="icon__overflow"></span></Dropdown></li> */}
          {/* <li className={styles.dividerLine}><div /></li> */}
          <li className={styles.closetab} onClick={()=>cancelWindow()}><span className={`icon__profileClose darkbg`}></span></li>
        </ul>
        {/* <li className={`${ chatReducer.isKey==="" ||chatReducer.isKey==="all"  ? styles.active : styles.profiletab}`}
            onClick={() => rightSideChatToggle('all')}>
            <span className={`${chatReducer.isKey===""? "icon__profilestamp green" : "icon__profilestamp"}`}></span>Profile</li>
          <li className={`${activeTab === 'task' || chatReducer.isKey==="tasklist" ? styles.active : styles.tasktab}`}
            onClick={() => rightSideChatToggle('task')}>
            <span className={`${activeTab === 'task'|| chatReducer.isKey==="tasklist"  ? "icon__tickfill green" : "icon__tickfill green"}`}></span>Tasks</li>
          <li className={`${activeTab === 'event'||chatReducer.isKey==="eventlist" ? styles.active : styles.eventstab}`}
            onClick={() => rightSideChatToggle('event')}>
            <span className={`${activeTab === 'event' ||chatReducer.isKey==="eventlist"? "icon__noteactive green" : "icon__noteactive"}`}  ></span>Events</li>
          <li className={`${activeTab === 'notes' ||chatReducer.isKey==="notelist" ? styles.active : styles.notestab}`}
            onClick={() => rightSideChatToggle('notes')}>
            <span className={`${activeTab === 'notes' ||chatReducer.isKey==="notelist" ? "icon__eventactive green" : "icon__eventactive"}`}></span>Notes</li>
          <li><Dropdown overlay={menu} overlayClassName="customwidsetcon" trigger={['click']} placement="bottomRight">
            <span className="icon__overflow"></span></Dropdown>More</li>
        </ul> */}
      </div>
      {/*<div className={styles.menupopups}>
        <ul>
          <li>Saved Chats</li>
          <li>Chats with links</li>
        </ul>
  </div>*/}
    </>
  );
};

